'use strict';

import register from './core';
import { isValidPhrase } from '../functions/search-common';

register('search', function (element) {
  var $form = $('#search-form');
  var infinite = null;

  var initInfinite = function () {
    if (infinite)
      infinite.destroy();

    infinite = new Waypoint.Infinite({
      element: $('.list__list')[0],
      items: '.list__item',
      onBeforePageLoad: function () {
        var moreResSelector = '#searchMoreResults', nextLink = $(moreResSelector).attr('href');
        $(moreResSelector).attr('href', nextLink += "&ajax=true");
      },
      onAfterPageLoad: function () { }
    });
  };

  var getCurrentUrl = function (query, category) {
    return encodeURI(window.location.pathname + '?q=' + query + '&category=' + category);  
  };

  var toggleDisabled = function (setDisabled) {
    var $main = $('#main'), fadeActiveClass = 'fade-content--active';
    $form.find('fieldset').prop('disabled', setDisabled);
    setDisabled ? $main.addClass(fadeActiveClass) : $main.removeClass(fadeActiveClass);
  };

  initInfinite();

  $form.on('submit', function (e) {
    e.preventDefault();
    var query = $('#search-query').val();

    if (!isValidPhrase(query))
      return false;

    var category = $('#filter-group input[name=category]:checked').val();
    var url = getCurrentUrl(query, category);

    toggleDisabled(true);

    $('#search-result').load(url + ' ' + '#search-container', function (data) {
      var filterGroup = '#filter-group',
        searchMeanId = '#search-mean';
      $(searchMeanId).html($(data).find(searchMeanId).html());
      $(filterGroup).html($(data).find(filterGroup).html());

      $('#info-container').html($(data).find('#info-container').html());

      if (history.pushState)
        window.history.pushState(null, '', url);
      
      toggleDisabled(false);
      initInfinite();
    });
  });
});
